export default "__VITE_ASSET__DYCVpyVG__"